import _sumBy2 from "lodash/sumBy";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import cn from 'classnames';
import React from 'react';
import Loading from 'swag-client-common/components/info/loading';
import BoxItemsSummary from 'swag-client-common/components/partials/box-items-summary';
import { OrderItem } from 'swag-client-common/components/partials/cart/cart-item';
import { SUPER_SPEED } from 'swag-client-common/constants';
import { getBoxItemsPricing } from 'swag-common/business-logic/order/get-box-items-pricing.logic';
import { SWAG_IN_A_BOX } from 'swag-common/constants/box-titles';
import { DesignUploadMode } from 'swag-common/interfaces';
import { getImageOfItem } from '../../../../../../redux/cart/cart.utils';
import { BoxNotecardAndCrinklePaper } from '../box-notecard-and-crinkle-paper';
import ItemsBlockWrapper from '../items-block-wrapper';
import { setWithBorderFlag } from '../order-item-list/order-item-list-other.utils';
import classes from './box-order-item-list.scss';
const styles = {
  loading: {
    position: 'absolute'
  }
};
class BoxOrderItemList extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleSampleClick", () => {
      const {
        isCart,
        items,
        onBoxSampleClick
      } = this.props;
      const [firstItem] = items;
      onBoxSampleClick(isCart ? firstItem._id : null);
    });
  }
  render() {
    const {
      items,
      selectedItem,
      isLoading,
      isSampleButtonShown,
      isCart,
      isWholeBoxSuperSpeed,
      isSuperSpeedAddonWarn,
      isPreBuiltLimitedCart,
      isResellerInOrderCreationMode,
      productionTimeList,
      onMoveToCart,
      onMoveToDraft,
      onRemoveItem,
      onEditRequest,
      onEditSizeOfSample,
      onClickMockup,
      onShareClick,
      onProductionTimeClick,
      onProductionTimeChange,
      onSizeClick,
      onQuantityClick,
      isPlainCard = true
    } = this.props;
    const [firstItem] = items;
    const {
      total,
      itemPrice,
      totalBoxSetupFee
    } = getBoxItemsPricing(items);
    const moveAction = isCart ? onMoveToDraft : onMoveToCart;
    const oldSetupFee = _sumBy2(items, 'oldSetupFee');
    const isOrderMore = Boolean(firstItem.customProductId) && firstItem.isReorder;
    return /*#__PURE__*/React.createElement("div", {
      key: firstItem._id,
      className: cn(classes.container, {
        [classes.withSuperSpeedColorText]: isWholeBoxSuperSpeed,
        [classes.isPlainCard]: isPlainCard
      }),
      "data-box-container": firstItem._id
    }, isLoading && selectedItem === firstItem._id && /*#__PURE__*/React.createElement(Loading, {
      className: classes.loading,
      style: styles.loading
    }), /*#__PURE__*/React.createElement("span", {
      className: cn(classes.header, {
        [classes.withSuperSpeed]: isWholeBoxSuperSpeed,
        [classes.isPlainCard]: isPlainCard
      })
    }, isSampleButtonShown && /*#__PURE__*/React.createElement("p", {
      className: classes.sample,
      onClick: this.handleSampleClick,
      "data-button": "NeedSample"
    }, "Need a sample?"), /*#__PURE__*/React.createElement("p", null, `${SWAG_IN_A_BOX}${isWholeBoxSuperSpeed ? SUPER_SPEED : ''}`), !isPreBuiltLimitedCart && !isResellerInOrderCreationMode ? /*#__PURE__*/React.createElement("p", {
      className: classes.draft,
      onClick: () => moveAction === null || moveAction === void 0 ? void 0 : moveAction(firstItem._id),
      "data-button": isCart ? 'MoveBoxToDraft' : 'MoveBoxToCart'
    }, isCart ? 'Save for later' : 'Add to cart') : null), items.map((boxItem, index) => /*#__PURE__*/React.createElement(ItemsBlockWrapper, {
      key: boxItem._id,
      withBorder: setWithBorderFlag(items.length, index),
      isLastItem: items.length - 1 === index,
      isPlainCard: isPlainCard,
      itemWrapperClassName: classes.itemWrapper
    }, /*#__PURE__*/React.createElement(OrderItem, {
      itemLogoSrc: getImageOfItem(boxItem),
      index: index,
      item: boxItem,
      removeItem: onRemoveItem,
      onEditRequest: onEditRequest,
      onEditSizeOfSample: onEditSizeOfSample,
      onClickMockup: onClickMockup,
      moveToDraft: onMoveToDraft,
      onShareClick: onShareClick,
      onProductionTimeClick: onProductionTimeClick,
      onProductionTimeChange: onProductionTimeChange,
      onSizeClick: onSizeClick,
      isFullDesign: boxItem.prod.designUploadMode === DesignUploadMode.fullDesign,
      isThisItemBox: boxItem.prod.designUploadMode === DesignUploadMode.box,
      onQuantityClick: onQuantityClick,
      isLoading: isLoading,
      selectedItem: selectedItem,
      isSavedForLater: !isCart,
      isRemoveAvailable: true,
      isBoxItem: true,
      isOrderMore: isOrderMore,
      isWholeBoxSuperSpeed: isWholeBoxSuperSpeed,
      isSuperSpeedAddonWarn: isSuperSpeedAddonWarn
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoxNotecardAndCrinklePaper, {
      boxItemsId: items[0].boxItemsId
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.summaryContainer
    }, /*#__PURE__*/React.createElement(BoxItemsSummary, {
      total: total,
      setupFee: totalBoxSetupFee,
      oldSetupFee: oldSetupFee,
      itemPrice: itemPrice,
      prodTime: firstItem.prodTime,
      productionTimeList: productionTimeList,
      wrapperClassName: classes.summaryWrapper,
      onProductionTimeChange: time => onProductionTimeChange(time, firstItem),
      onProductionTimeClick: () => onProductionTimeClick(firstItem)
    })));
  }
}
export default BoxOrderItemList;